import { FilterObj } from 'ziti-console-lib';

const DEFAULT_HOURS = 24;

/** One date end, decoded; a malformed escape in a shared URL yields '' so the end is skipped. */
function decodeEnd(end: string): string {
    try {
        return decodeURIComponent(end);
    } catch {
        return '';
    }
}

/** The span an events list asks for: its date filter, or the last day when there is none. */
export function eventsTimeRange(
    filters: FilterObj[],
    columnId: string
): { start: Date; end: Date; hours: number; custom: boolean } {
    const value = filters.find((item) => item.columnId === columnId)?.value;
    // A date filter holds its two ends, encoded; a shared URL restores them as one comma-joined string.
    const ends = (Array.isArray(value) ? value : String(value ?? '').split(','))
        .map((end) => decodeEnd(String(end).trim()))
        .filter((end) => !!end);
    const start = ends[0] ? new Date(ends[0]) : undefined;
    const end = ends[1] ? new Date(ends[1]) : undefined;
    if (start && end && !isNaN(start.getTime()) && !isNaN(end.getTime())) {
        return { start, end, hours: Math.max(1, Math.ceil((Date.now() - start.getTime()) / 3600000)), custom: true };
    }
    const now = new Date();
    return { start: new Date(now.getTime() - DEFAULT_HOURS * 3600000), end: now, hours: DEFAULT_HOURS, custom: false };
}

/** What a select or text filter holds, as text. */
export function eventsFilterText(filters: FilterObj[], columnId: string): string {
    return String(filters.find((item) => item.columnId === columnId)?.value ?? '').trim();
}
